import { useT } from '../app/preferences.ts';
import { BigTile } from '../components/BigTile.tsx';
import { Link } from '../components/Link.tsx';
import { InfoLinks } from './InfoPage.tsx';

export function HomePage() {
  const t = useT();

  return (
    <div className="page-fill home">
      <section className="home-hero">
        <div className="home-pieces" aria-hidden="true">
          <span>♞</span>
          <span>♛</span>
          <span>♚</span>
          <span>♜</span>
        </div>
        <h1 className="hero-title">
          {t('home.title.a')}
          <em>{t('home.title.b')}</em>
        </h1>
        <p className="hero-lead">{t('home.lead')}</p>
      </section>

      <section className="mode-grid pop-in three">
        <BigTile
          href="/online"
          kind="online"
          art="🌍"
          title={t('home.online.title')}
          desc={t('home.online.desc')}
          go={t('home.go')}
        />
        <BigTile
          href="/computer"
          kind="computer"
          art="🤖"
          title={t('home.computer.title')}
          desc={t('home.computer.desc')}
          go={t('home.go')}
        />
        <BigTile
          href="/friend"
          kind="friend"
          art="🤝"
          title={t('home.friend.title')}
          desc={t('home.friend.desc')}
          go={t('home.go')}
        />
      </section>

      <nav className="home-links pop-in" aria-label={t('nav.home')}>
        <Link href="/leaderboard" className="btn">
          <span className="emoji" aria-hidden="true">
            🏆
          </span>
          {t('home.leaderboard')}
        </Link>
        <Link href="/market" className="btn">
          <span className="emoji" aria-hidden="true">
            🛍️
          </span>
          {t('home.market')}
        </Link>
      </nav>

      <InfoLinks />
    </div>
  );
}
